<!-- GENERAL -->
<fieldset class="wizard-chapter is--active">
  <legend class="form-title">General</legend>
  <ul class="form-wizard-list">

    <li class="form-wizard-item">
      <label for="text_field_url" class="required wizard-label">Add item to social wall</label>
      <input type="text" id="text_field_url" name="Url to add" placeholder="Post url" #urlInput (keydown.enter)="addItem(urlInput.value); urlInput.value = ''" />
    </li>
  </ul>
</fieldset>

<div class="social-wall__container" masonry-grid>
  <ng-container [ngSwitch]="p.Type" *ngFor="let p of posts">
    <!-- type social -->
    <article class="social-wall__container__item" *ngSwitchDefault>
      <header class="social-wall__container__item__header">
        <span class="social-wall__container__item__header__title">
          <strong>{{p.Author}}</strong>
        </span>
        <span class="social-wall__container__item__header__title">
          <time>{{p.DateAdded | amTimeAgo}} on {{p.HostName}}</time>
        </span>
      </header>
      <main class="social-wall__container__item__content">
        <figure>
          <figcaption class="social-wall__container__item__content__description">
            <p [innerHTML]="p.Description"></p>
          </figcaption>
          <img 
            class="social-wall__container__item__content__img" 
            [src]="p.ImageUrl" 
            alt="" 
            (load)="updateBricks()"
            *ngIf="p.ImageUrl && !p.VideoUrl">
          <div class="social-wall__container__item__content__video" *ngIf="p.VideoUrl">
            <video 
              [src]="p.VideoUrl" 
              [attr.poster]="p.ImageUrl" 
              playsinline 
              preload="none" 
              type="video/mp4" 
              (canplay)="updateBricks()"
              (click)="togglePlay($event)">
            </video>
            <span class="icon icon--right icon--play is--icon-play">
              <svg class="icon-svg">
                <use xlink:href="assets/gfx/svg-sprite.svg#icon-play"></use>
              </svg>
            </span>
          </div>
        </figure>
      </main>

      <button class="social-wall__container__delete" (click)="onDelete.emit(p.Id);">
        Delete
        <span class="icon icon--right icon--cross is--icon-cross">
          <svg class="icon-svg">
            <use xlink:href="assets/gfx/svg-sprite.svg#icon-cross"></use>
          </svg>
        </span>
      </button>
    </article>

    <!-- type news -->
    <article class="social-wall__container__item type--news" *ngSwitchCase="'article'">
      <header class="social-wall__container__item__header">
        <time class="social-wall__container__item__header__date">{{p.DateAdded | amTimeAgo}}</time>
      </header>
      <main class="social-wall__container__item__content">
        <h1>{{p.Title}}</h1>
        <strong>{{p.HostName}}</strong>
      </main>

      <button class="social-wall__container__delete" (click)="onDelete.emit(p.Id)">
        Delete
        <span class="icon icon--right icon--cross is--icon-cross">
          <svg class="icon-svg">
            <use xlink:href="assets/gfx/svg-sprite.svg#icon-cross"></use>
          </svg>
        </span>
      </button>
    </article>
  </ng-container>
</div>